'use client';

import { Typography } from 'components';
import { AiSubStep, AiSubStepTypeEnum, Maybe } from 'gql/graphql';
import { useTranslations } from 'next-intl';
import { FC, PropsWithChildren, useMemo } from 'react';

interface ILanguagesStepRun {
  subSteps?: Maybe<AiSubStep[]>;
  sourceLanguageCode?: Maybe<string>;
}

const LanguagesStepRun: FC<PropsWithChildren<ILanguagesStepRun>> = ({
  subSteps,
  sourceLanguageCode
}) => {
  const t = useTranslations();

  const subStepSourceLanguage = subSteps?.find(
    (subStep) => subStep.type === AiSubStepTypeEnum.SourceLanguageCode
  );

  const subStepTargetLanguages = subSteps?.find(
    (subStep) => subStep.type === AiSubStepTypeEnum.TargetLanguageCodes
  );

  const memoizedSourceLanguageCode = useMemo(() => {
    const valueFromSteps = subStepSourceLanguage?.content?.value;

    return (sourceLanguageCode || valueFromSteps || '').toLocaleUpperCase();
  }, [sourceLanguageCode, subStepSourceLanguage?.content?.value]);

  const targetLanguageCodes = useMemo(() => {
    try {
      return JSON.parse(subStepTargetLanguages?.content?.value as string) as string[];
    } catch (error) {
      return [];
    }
  }, [subStepTargetLanguages]);

  return (
    <>
      {subStepTargetLanguages && subStepSourceLanguage && (
        <div className="flex pt-2">
          <Typography variant="regular5" className="w-4/5 text-tertiary-200">
            {t('labels.language_pairs')}:
          </Typography>
          <Typography variant="regular5" className="w-full !leading-4 text-tertiary-100">
            {memoizedSourceLanguageCode}
            {` ${t('labels.to')} `}
            {targetLanguageCodes?.map(
              (code, codeIndex) =>
                `${code.toLocaleUpperCase()}${
                  codeIndex !== (targetLanguageCodes.length ?? 0) - 1 ? ', ' : ''
                }`
            )}
          </Typography>
        </div>
      )}
    </>
  );
};

export default LanguagesStepRun;
